import React, { useMemo } from 'react';
import { BsArchiveFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Flex, Icon, IconButton, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../../constants/analyticsIds';
import { showModal } from '../../../../../redux/modules/modal';
import { useInsuredActiveRecordsData } from '../../../../../services/insured-service';
import { getInfiniteListDataLength } from '../../../../../services/util';
import radii from '../../../../../styles/theme/foundation/radii';

import ArchivedRecordsModal from './ArchivedRecordsModal';

const RecordsHeader = ({ insuredId }) => {
  const dispatch = useDispatch();
  const { data: activeRecords, isLoading } = useInsuredActiveRecordsData({ insuredId });

  const activeRecordsLength = useMemo(() => {
    if (isLoading) {
      return 'loading...';
    }

    return getInfiniteListDataLength(activeRecords);
  }, [activeRecords]);

  const showArchivedRecordsModal = () => {
    dispatch(showModal(() => <ArchivedRecordsModal insuredId={insuredId} />, {
      title: 'Archived Records',
      maxWidth: 1040
    }));
  };

  return (
    <Box>
      <Flex
        alignItems="center"
        bg="primaryScale.600"
        borderRadius={`${radii.md} ${radii.md} 0 0`}
        height="48px"
        justifyContent="space-between"
        padding={4}
        position="relative"
        width="100%"
      >
        <Text
          color="white"
          textStyle="bodyMd600"
        >
          {`Active Records (${activeRecordsLength})`}
        </Text>
        <IconButton
          data-analytics-id={analyticsIds.insuredProfilePage.recordsComponent.archivedRecords}
          icon={<Icon as={BsArchiveFill} boxSize="20px" />}
          variant="textWhite"
          onClick={showArchivedRecordsModal}
        />
      </Flex>
    </Box>
  );
};

RecordsHeader.propTypes = { insuredId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) };

export default RecordsHeader;
